module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p8"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle "
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IREN SCREAMING")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HARKNESS")]), _vm._v(" speeds west down Route 2, parting the cars on the crowded highway and racing past them. “Young, Fast, Iranians” blares from the shitty speakers. The dashboard clock moves closer to seven. The road rises slowly and crosses flatland marshes and low hills, maples flaming and fields blanched by an early frost.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness learned to drive here, going to Cambridge for hardcore shows at the Middle East or to hang out next to the Harvard Square T stop. Although he did stupid things when he was younger, Harkness never would have lost a gun.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("He turns down the F.U.’s in midscream and dials Narco-Intel, its number as familiar as his own.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Harky-Hark. Up with the sun, are you?” Patrick’s familiar voice cheers him for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Driving to work,” Harkness says. “I need you to check something for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You ask, we do it. You know how we are here, Harky. Like your loving family of misfit toys.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What do you need?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness thinks about telling Patrick about his lost gun but stops himself. “Guy called me late last night pretending to be Pauley Fitz.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Sick fuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Can you look up a cell phone number and see if it’s his?” Harkness checks his phone and reads the number.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That dude’s dead, Harky. Footnote to history. Stain on the Pike.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The guy who called me wasn’t dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Right. So can you check it out?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Not a problem, boss.” Patrick pauses. “When you coming back?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Future cloudy. Check back later,” Harkness says.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Don’t go all Magic 8 Ball on me.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Wisdom comes from unusual sources.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No doubt about that Harky. No doubt.”")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Harkness drives past the exits for Concord and spins through a traffic rotary next to a state prison topped with concertina wire shimmering in the morning sun. He found an inmate’s stash of PCP in a drainpipe there once, dangling from a thread of bright white dental floss. Like many hides—great concept, lazy execution.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("In a few minutes, the white church spires rise above the thick pine forest. Tumbled walls of gray stones border ancient fields dotted with rusting tractors and sagging barns. Harkness is home now, crossing the town line into Nagog, a colonial town ten miles square, home to ten thousand no-nonsense New Englanders. Cities churn, suburbs strive, but small towns stay the same. Harkness knows almost everyone who lives in Nagog. And everyone knows him.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("After the incident, the BPD internal review put Harkness on unpaid administrative leave for a year, a polite way to get him out of the way. Taking a patrolman gig in his quiet hometown seemed like a penance at first. But when Boston scorned him, when his name became a punch line in the comedy clubs, when Sox fans held up signs with his face on it in the Fenway Park bleachers, when "), _c('em', [_vm._v("Boston Herald")]), _vm._v(" editorials railed against him—Harkness was relieved to be back home, serving out his time in the minor league of law enforcement.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Like any small town, Nagog can be annoying. Young moms in Lululemon yoga pants clog the booths at the Nagog Bakery. Elders in Outbacks drift from lane to lane, lost in memories or transfixed by foliage. Guys smelling like vodka and toothpaste hog the public computers at the library while they check their stock portfolios. Rich kids in expensive leather jackets skulk around the parking lot of the E-Z Mart. But his hometown has an old-fashioned reserve and politeness that Harkness admires, craves even.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Nagog isn’t very exciting, but it’s predictable. And sometimes that’s enough.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center graphic break"
  }, [_vm._v("· · ·")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("The Nagog Five and Ten isn’t open yet but Harkness knocks when he sees Lee walking around inside.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lee peers through his thick glasses and comes to the door, twisting the deadbolt open. “Eddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Lee.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Short and owlish, wearing an AC/DC T-shirt and baggy jeans, Lee looks pretty much the same as he did every day in high school. “Need something?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness pauses for a second and thinks about whether he should tell Lee. They’ve known each other since grade school. And he really doesn’t have a choice. “Yeah,” Harkness says. “I need a gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Don’t they give you one of those when you’re a cop? Even here?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“They do. But it looks like I . . . left mine somewhere.” Harkness lifts his leather jacket and points to the empty holster. “Need something to fill in for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“A stunt gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Right, a stunt gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You’ve come to the right place.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("They walk inside. The dark store smells like a laboratory storeroom, safe and scientific.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lee points. “Over in aisle two.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Three aisles stretch from front to back of the store, lined with office supplies, toys, and cheap candy—all organized by Lee and his acolytes of old-school retail. They come to a pegboard of toy guns—silver cap pistols, ray guns, potato guns, and dozens more. Harkness tries to concentrate but his eyes unfocus. Lee’s dark store is cluttered and overwhelming. And last night still hovers like an inexplicable storm cloud.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lee picks up a brown, furry gun with a smiling monkey face at the end of the barrel. “Want a monkey gun? We’ve sold lots of them.” When he squeezes the trigger a scream echoes through the store.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I think I need something less furry.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“We had to take the real-looking ones off the shelves a couple of years back,” Lee says. “People were using them to rob banks and what have you.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness glances at the clock over the door. There’s less than five minutes to get to the station or face the wrath of the Sweathog.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Let me check out back.” Lee runs to the storage room and comes back carrying a gray plastic handgun with a brown grip. Harkness unsnaps his holster and Lee drops in the toy gun. “Perfect fit.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Handle’s kind of shiny. People might be able to tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Lee holds a finger in the air then rushes across the store. He comes back with a piece of sandpaper from the hardware aisle and dulls the grip with an expert rub.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Thanks, looks great,” Harkness says. “You’re a genius.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And look where it got me?” Lee points around the store. “Selling candy and trash bags.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness reaches for his wallet but Lee waves him away.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“But here . . . you’ll need these.” Lee dumps a handful of bright plastic disks into his hand. “It shoots them. Let me know if you need more.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Harkness smiles. “I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And Eddy?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("They stop at the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I think you might need this, too.” Lee throws him a roll of mints from the counter. “You smell like a bar.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a21ac11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c04.vue
// module id = 84
// module chunks = 0